import { useMutation as s } from "@tanstack/react-query";
import { useAuthStore as i, setSubscriptionPlan as u, getCurrentUser as c } from "@waitroom/auth";
import { activateTrialMutation as m, getRequestData as p } from "@waitroom/react-query";
const g = (o) => {
  const { userId: r, accessToken: a } = i(), t = m({
    userId: r,
    accessToken: a
  });
  return s({
    ...o,
    ...t,
    mutationFn: async () => {
      const e = await t.mutationFn(), n = p(e);
      return n && u(n), await c(), e;
    }
  });
};
export {
  g as useActivateTrial
};
